// antd
import { Row } from 'antd';
import React from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import routePathEnum from 'enums/routePathEnum';

interface ILogin {}

const ErrPage: React.FC<ILogin> = () => {
    const { navigateWorkaround } = useNavigateWorkaround();

    return (
        <AuthWrapper>
            <Title text="BANKSIGN_ERR" level={5} />

            <Row className="button-row">
                <ButtonComponent
                    buttontext="PRIHLASIT_SE"
                    type="primary"
                    onClick={() => navigateWorkaround(routePathEnum.LOGIN_ROZCESTNIK)}
                    id="loginRedirectBtn"
                />
                <AnchorComponent href="https://www.cdcp.cz/">
                    <ButtonComponent buttontext="PREJIT_NA_CDCP" type="primary" id="cdcpRedirectBtn" />
                </AnchorComponent>
            </Row>
        </AuthWrapper>
    );
};

export default ErrPage;
